var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"max-h-128 object-scale-down",attrs:{"src":_vm.defaults[_vm.type].src,"srcset":_vm.defaults[_vm.type].srcset,"alt":_vm.alt,"title":_vm.alt,"loading":"lazy","sizes":_vm.size,"width":"700px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }